export const countDelivered = (element) =>
	element.value.reduce(
		(prev, next) =>
			prev +
			(['delivered_no_payment', 'delivered'].includes(next.shipping.status)
				? 1
				: 0),
		0,
	);
